import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=213d785e&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('213d785e')) {
      api.createRecord('213d785e', component.options)
    } else {
      api.reload('213d785e', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=213d785e&", function () {
      api.rerender('213d785e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2WN7Nc6LG93E8/JS/offershelp.vue"
export default component.exports